export type TNotification = {
  body: string;
  createdAt: string;
  id: number;
  read: boolean;
  type: ENotification;
};

export enum ENotification {
  ADMIN = 'ADMIN',
  PROMOTION = 'PROMOTION',
  TAGGED_ENTITY = 'TAGGED_ENTITY'
}
